<template>
  <div class="visit-record-form-container">
    <el-form :model="visitRecordForm" :rules="visitRecordRules" ref="visitRecordForm" label-width="120px">
      <!-- 关联客户信息（可搜索，支持按名称/手机/地址快速筛选） -->
      <el-form-item label="关联客户">
        <el-select
          v-model="visitRecordForm.customerId"
          placeholder="请选择客户（可输入名称、手机号或地址搜索）"
          :disabled="!!recordId"
          filterable
          :filter-method="filterCustomerOptions"
          style="width: 100%"
        >
          <el-option
            v-for="customer in filteredCustomersForSelect"
            :key="customer.id"
            :label="customer.name"
            :value="customer.id"
          >
            <span>{{ customer.name }}</span>
            <span v-if="customer.phone" class="option-extra"> {{ customer.phone }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      
      <!-- 用药时间 -->
      <el-form-item label="用药时间" prop="medicineTime">
        <el-date-picker
          v-model="visitRecordForm.medicineTime"
          type="datetime"
          placeholder="请选择用药时间"
          style="width: 100%"
        ></el-date-picker>
      </el-form-item>
      
      <!-- 回访时间 -->
      <el-form-item label="回访时间" prop="visitTime">
        <el-date-picker
          v-model="visitRecordForm.visitTime"
          type="datetime"
          placeholder="请选择回访时间"
          style="width: 100%"
        ></el-date-picker>
      </el-form-item>
      
      <!-- 用药记录 -->
      <el-form-item label="用药记录" prop="medicineRecord">
        <el-input
          v-model="visitRecordForm.medicineRecord"
          type="textarea"
          :rows="4"
          placeholder="请输入用药记录"
        ></el-input>
      </el-form-item>
      
      <!-- 用肥记录 -->
      <el-form-item label="用肥记录" prop="fertilizerRecord">
        <el-input
          v-model="visitRecordForm.fertilizerRecord"
          type="textarea"
          :rows="4"
          placeholder="请输入用肥记录"
        ></el-input>
      </el-form-item>
      
      <!-- 效果观察记录 -->
      <el-form-item label="效果观察记录" prop="effectObservation">
        <el-input
          v-model="visitRecordForm.effectObservation"
          type="textarea"
          :rows="4"
          placeholder="请输入效果观察记录（出苗率、株高、数量、果枝序数、棉桃数量等）"
        ></el-input>
      </el-form-item>
      
      <!-- 问题备注 -->
      <el-form-item label="问题备注" prop="problemNotes">
        <el-input
          v-model="visitRecordForm.problemNotes"
          type="textarea"
          :rows="4"
          placeholder="请输入问题备注"
        ></el-input>
      </el-form-item>
      
      <!-- 图片上传 -->
      <el-form-item label="回访图片" class="upload-item">
        <el-upload
          v-model="visitRecordForm.images"
          ref="upload"
          action="#"
          :http-request="handleHttpRequest"
          :before-upload="beforeImageUpload"
          :multiple="true"
          :limit="10"
          :on-success="handleImageUploadSuccess"
          :on-error="handleImageUploadError"
          :on-remove="handleImageRemove"
          :file-list="imageFileList"
          :on-exceed="handleExceed"
          :on-preview="handlePictureCardPreview"
          list-type="picture-card"
          accept=".jpg,.jpeg,.png"
        >
          <div class="upload-card-inner">
            <i class="el-icon-plus upload-plus-icon"></i>
            <span class="upload-text">上传图片</span>
          </div>
          <div slot="tip" class="el-upload__tip">
            只能上传 jpg/png 文件，最多上传 10 张，单张不超过 10MB
          </div>
        </el-upload>
        
        <!-- 图片预览 -->
        <el-dialog
          :visible.sync="dialogVisible"
          title="图片预览"
          width="80%"
        >
          <img
            v-if="dialogImageUrl"
            :src="dialogImageUrl"
            style="width: 100%;"
          >
        </el-dialog>
      </el-form-item>
      
      <!-- 记录人 -->
      <el-form-item label="记录人">
        <el-select v-model="visitRecordForm.recorderId" placeholder="请选择记录人" :disabled="true">
          <el-option
            v-for="user in users"
            :key="user.id"
            :label="user.name"
            :value="user.id"
          ></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
        <el-button @click="handleReset">重置</el-button>
        <el-button @click="$router.go(-1)">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import request from '../utils/request'
import { getUserInfo } from '../utils/auth'
import { filterCustomersByDataPermission } from '../utils/dataPermission'

export default {
  name: 'VisitRecordForm',
  props: {
    recordId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      visitRecordForm: {
        id: null,
        medicineTime: null,
        visitTime: null,
        medicineRecord: '',
        fertilizerRecord: '',
        effectObservation: '',
        problemNotes: '',
        customerId: null,
        recorderId: null,
        images: [] // 图片列表
      },
      visitRecordRules: {
        medicineTime: [
          { required: true, message: '请选择用药时间', trigger: 'change' }
        ],
        visitTime: [
          { required: true, message: '请选择回访时间', trigger: 'change' }
        ],
        medicineRecord: [
          { required: true, message: '请输入用药记录', trigger: 'blur' }
        ],
        fertilizerRecord: [
          { required: true, message: '请输入用肥记录', trigger: 'blur' }
        ],
        effectObservation: [
          { required: true, message: '请输入效果观察记录', trigger: 'blur' }
        ],
        problemNotes: [
          { required: true, message: '请输入问题备注', trigger: 'blur' }
        ]
      },
      customers: [], // 客户列表
      customerFilterQuery: '', // 关联客户下拉搜索关键词
      users: [], // 用户列表
      currentUser: null, // 当前登录用户
      uploadUrl: '/api/upload', // 图片上传URL
      imageFileList: [], // 上传文件列表
      dialogVisible: false, // 图片预览对话框显示状态
      dialogImageUrl: '' // 预览图片URL
    }
  },
  computed: {
    authHeaders() {
      try {
        const token = localStorage.getItem('token')
        return token ? { 'Authorization': `Bearer ${token}` } : {}
      } catch (error) {
        return {}
      }
    },
    // 关联客户下拉：按关键词过滤（名称、手机号、地址）
    filteredCustomersForSelect() {
      const q = (this.customerFilterQuery || '').trim().toLowerCase()
      if (!q) return this.customers
      return this.customers.filter(c => {
        const name = (c.name || '').toLowerCase()
        const phone = (c.phone || '').toLowerCase()
        const address = (c.address || '').toLowerCase()
        return name.includes(q) || phone.includes(q) || address.includes(q)
      })
    }
  },
  mounted() {
    // 先获取当前登录用户信息
    const currentUser = getUserInfo()
    if (currentUser) {
      this.currentUser = currentUser
      this.visitRecordForm.recorderId = currentUser.id
    }

    this.loadCustomers()
    this.loadUsers()
    
    // 如果是编辑模式，加载回访记录信息
    if (this.recordId) {
      this.loadVisitRecordInfo()
    } else {
      // 如果是新增模式，从URL参数获取客户ID
      const customerId = this.$route.query.customerId
      if (customerId) {
        this.visitRecordForm.customerId = parseInt(customerId)
      }
    }
  },
  methods: {
    // 关联客户下拉搜索时由 el-select 调用
    filterCustomerOptions(query) {
      this.customerFilterQuery = query
    },
    // 加载客户列表
    loadCustomers() {
      request.get('/customers')
        .then(response => {
          const all = response.data || response
          this.customers = filterCustomersByDataPermission(all || [], this.currentUser)
        })
        .catch(error => {
          console.error('加载客户列表失败:', error)
          this.$message.error('加载客户列表失败')
        })
    },
    
    // 加载用户列表
    loadUsers() {
      request.get('/users')
        .then(response => {
          this.users = response.data || response
        })
        .catch(error => {
          console.error('加载用户列表失败:', error)
          this.$message.error('加载用户列表失败')
        })
    },
    
    // 处理图片上传成功
    handleImageUploadSuccess(response, file, fileList) {
      // 将上传成功的图片URL添加到表单中
      if (response && response.url) {
        this.visitRecordForm.images.push(response.url)
      }
      // 确保fileList中的文件对象包含response属性
      this.imageFileList = fileList.map(item => {
        // 如果是当前上传的文件，确保它有response属性
        if (item.uid === file.uid) {
          return { ...item, response }
        }
        return item
      })
      this.$message.success('图片上传成功')
    },
    
    // 处理图片上传失败
    // eslint-disable-next-line no-unused-vars
    handleImageUploadError(error, file, fileList) {
      this.$message.error('图片上传失败')
    },
    
    // 处理图片移除
    handleImageRemove(file, fileList) {
      // 从表单中移除对应的图片URL
      const imageUrl = file.url || (file.response ? file.response.url : '')
      if (imageUrl) {
        const index = this.visitRecordForm.images.indexOf(imageUrl)
        if (index > -1) {
          this.visitRecordForm.images.splice(index, 1)
        }
      }
      this.imageFileList = fileList
    },
    
    // 处理图片超出限制
    // eslint-disable-next-line no-unused-vars
    handleExceed(files, fileList) {
      this.$message.warning(`最多只能上传10张图片`)
    },
    
    // 处理图片预览
    handlePictureCardPreview(file) {
      // 添加空值检查，确保访问安全
      this.dialogImageUrl = file.url || (file.response ? file.response.url : '')
      this.dialogVisible = true
    },
    
    // 上传前校验：仅允许 jpg/jpeg/png，单张 ≤10MB（与后端一致，未登录时 request 会 401）
    beforeImageUpload(file) {
      const allowedTypes = ['image/jpeg', 'image/png']
      const allowedExt = ['.jpg', '.jpeg', '.png']
      const ext = file.name ? file.name.substring(file.name.lastIndexOf('.')).toLowerCase() : ''
      if (!allowedExt.includes(ext) || !allowedTypes.includes(file.type)) {
        this.$message.error('只能上传 jpg、jpeg、png 格式的图片')
        return false
      }
      const maxSize = 10 * 1024 * 1024
      if (file.size > maxSize) {
        this.$message.error('单张图片不能超过 10MB')
        return false
      }
      return true
    },
    // 自定义文件上传请求（会带 token，未登录则 401）
    handleHttpRequest(options) {
      const formData = new FormData()
      formData.append('file', options.file)

      request.post('/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then(response => {
          options.file.response = response
          options.onSuccess(response, options.file, this.imageFileList)
        })
        .catch(error => {
          const msg = (error.response && error.response.data && error.response.data.message) || error.message || '上传失败'
          this.$message.error(msg)
          options.onError(error, options.file, this.imageFileList)
        })
    },
    
    // 加载回访记录信息
    loadVisitRecordInfo() {
      request.get(`/visit-records/${this.recordId}`)
        .then(response => {
          const record = response.data || response
          
          // 设置表单基本信息
          this.visitRecordForm = {
            id: record.id,
            medicineTime: new Date(record.medicineTime),
            visitTime: new Date(record.visitTime),
            medicineRecord: record.medicineRecord,
            fertilizerRecord: record.fertilizerRecord,
            effectObservation: record.effectObservation,
            problemNotes: record.problemNotes,
            customerId: record.customer.id,
            recorderId: record.recorder.id,
            images: record.images || [] // 加载已有的图片信息
          }
          
          // 构建已上传图片的文件列表，用于在上传组件中显示
          if (record.images && record.images.length > 0) {
            this.imageFileList = record.images.map((imageUrl, index) => {
              return {
                name: `image-${index + 1}`,
                url: imageUrl,
                uid: `-1${index}` // 使用负UID表示已存在的图片
              }
            })
          } else {
            // 清空图片文件列表
            this.imageFileList = []
          }
        })
        .catch(error => {
          console.error('加载回访记录信息失败:', error)
          this.$message.error('加载回访记录信息失败')
        })
    },
    
    // 提交表单
    handleSubmit() {
      this.$refs.visitRecordForm.validate((valid) => {
        if (valid) {
          // 构建请求数据 - 包含图片信息
          const requestData = {
            ...this.visitRecordForm,
            customer: { id: this.visitRecordForm.customerId },
            recorder: { id: this.visitRecordForm.recorderId },
            images: this.visitRecordForm.images || [] // 包含图片信息
          }
          
          // 根据是新增还是编辑选择请求方法
          const requestMethod = this.recordId ? request.put : request.post
          const requestUrl = this.recordId ? `/visit-records/${this.recordId}` : '/visit-records'
          
          requestMethod(requestUrl, requestData)
            .then(() => {
              this.$message.success(this.recordId ? '更新回访记录成功' : '添加回访记录成功')
              // 返回上一页或客户详情页
              if (this.visitRecordForm.customerId) {
                this.$router.push(`/customers/${this.visitRecordForm.customerId}`)
              } else {
                this.$router.go(-1)
              }
            })
            .catch(error => {
              console.error(this.recordId ? '更新回访记录失败:' : '添加回访记录失败:', error)
              this.$message.error(this.recordId ? '更新回访记录失败' : '添加回访记录失败')
            })
        }
      })
    },
    
    // 重置表单
    handleReset() {
      this.$refs.visitRecordForm.resetFields()
      
      // 重置记录人
      const currentUser = getUserInfo()
      if (currentUser) {
        this.visitRecordForm.recorderId = currentUser.id
      }
      
      // 保留客户ID
      const customerId = this.visitRecordForm.customerId
      this.visitRecordForm.customerId = customerId
      
      // 重置图片相关字段
      this.visitRecordForm.images = []
      this.imageFileList = []
      this.dialogVisible = false
      this.dialogImageUrl = ''
      
      // 清空上传组件
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles()
      }
    }
  }
}
</script>

<style scoped>
.visit-record-form-container {
  width: 100%;
}

.option-extra {
  color: #909399;
  font-size: 12px;
  margin-left: 8px;
}

/* 图片上传样式（PC 默认） */
.upload-item .el-form-item__content {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}

.visit-record-form-container .el-upload--picture-card {
  width: 120px;
  height: 120px;
  border-radius: 10px;
  border: 1px dashed #c0c4cc;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: normal !important;
}

.visit-record-form-container .el-upload-list--picture-card .el-upload-list__item {
  width: 120px;
  height: 120px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: normal !important;
}

.upload-card-inner {
  display: inline;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.upload-plus-icon {
  font-size: 26px;
  color: #409eff;
  margin-bottom: 0;
}

.upload-text {
  font-size: 13px;
  color: #606266;
}

.visit-record-form-container .el-upload__tip {
  margin-left: 16px;
  margin-top: 0;
  color: #909399;
  font-size: 13px;
  line-height: 1.6;
  max-width: 320px;
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .visit-record-form-container .el-form-item__label {
    font-size: 14px;
  }

  .upload-item .el-form-item__content {
    flex-direction: column;
    align-items: flex-start;
  }

  .visit-record-form-container .el-upload__tip {
    margin-left: 0;
    margin-top: 8px;
    max-width: none;
  }

  .visit-record-form-container .el-upload--picture-card,
  .visit-record-form-container .el-upload-list--picture-card .el-upload-list__item {
    width: 90px;
    height: 90px;
    line-height: 90px;
  }
}

/* 小屏幕手机适配 */
@media screen and (max-width: 480px) {
  .visit-record-form-container .el-upload--picture-card,
  .visit-record-form-container .el-upload-list--picture-card .el-upload-list__item {
    width: 70px;
    height: 70px;
    line-height: 70px;
  }

  .visit-record-form-container .el-upload-list--picture-card .el-upload-list__item-actions {
    height: 70px;
  }

  .visit-record-form-container .el-upload__tip {
    font-size: 12px;
  }
}
</style>